// extracted by mini-css-extract-plugin
module.exports = {"tagGroup":"_1Mou1VDlBDjP-HC7JvFzSq","tag":"iIlCUDGuCBxbY6SG2Ih6u","tagInput":"P2PdR4K8ZcOSNXF506oMQ"};